<template>
  <div class="max-w-screen-mobile mx-auto h-screen  py-2 relative">
    <OnboardingHeader :btnText="$t('onboarding.header')" />
    <div class="px-6 pt-4 pb-3.5">
      <p class="font-body text-bodyS text-redDamask tracking-midWide font-medium">{{ $t('onboarding.1') }}</p>
      <h4 class="font-heading text-h4 dark:text-potPourri text-sepiaBlack">{{ $t('onboarding.message') }}</h4>
      <p class="font-body text-bodyL dark:text-potPourri text-sepiaBlack leading-normal">{{ $t('onboarding.1text') }}</p>
    </div>
    <OnboardingFooter next="Onboarding2" prev="MobileMenu"/>
  </div>
</template>

<script>

import OnboardingHeader from '@/components/mobile/OnboardingHeader.vue';
import OnboardingFooter from '@/components/mobile/OnboardingFooter.vue';

export default {
  name: 'Onboard1',
  components: {
    OnboardingHeader,
    OnboardingFooter
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
  data() {
    return {
      lang: localStorage.getItem('language') ? localStorage.getItem('language') : 'ro',
    }
  }
}
</script>
